import React from "react";
//import styled from 'styled-components';
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { Title, Dot } from "../styles/GlobalStyles";

export default function Sponsors() {
  const data = useStaticQuery(graphql`
    {
      logoPetrol: file(relativePath: { eq: "Petrol_LOGO.png" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      logoGuardiaris: file(relativePath: { eq: "Guardiaris.png" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      sloveniaControl: file(relativePath: { eq: "SloveniaControl.png" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
    }
  `);
  return (
    <>
      <section className="body-font border-t-8 border-teal-50 text-gray-600">
        <div className="container mx-auto flex flex-wrap items-center px-5 py-24">
          <div class="mb-10 border-b border-gray-200 pb-10 md:mb-0 md:w-1/2 md:border-r md:border-b-0 md:py-8 md:pr-12">
            <h2 className="font-inter mb-8 text-3xl font-extrabold leading-none tracking-tight text-gray-900 sm:text-4xl lg:text-4xl">
              Bronasta sponzorja
            </h2>
            <div className="flex flex-wrap place-items-start items-start gap-14">
              <a href="https://www.petrol.si/">
                <GatsbyImage
                  image={data.logoPetrol.childImageSharp.gatsbyImageData}
                  className="block w-72 object-center"
                />
              </a>
              <a href="https://www.guardiaris.com/">
                <GatsbyImage
                  image={data.logoGuardiaris.childImageSharp.gatsbyImageData}
                  className="block w-72 object-center"
                />
              </a>
            </div>
          </div>
          <div className="flex flex-col self-start md:w-1/2 md:py-8 md:pl-12">
            <h2 className="font-inter mb-8 text-3xl font-extrabold leading-none tracking-tight text-gray-900 sm:text-4xl lg:text-4xl">
              Donator
            </h2>
            <a href="https://www.sloveniacontrol.si/">
              <GatsbyImage
                image={data.sloveniaControl.childImageSharp.gatsbyImageData}
                className="block w-60 object-center"
              />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
